module.exports = __webpack_public_path__ + "img/logo-mediotejo.38c88160.png";